module.exports = __webpack_public_path__ + "img/dragon tiger icon 3.c825cf6b.png";